import Swiper, { Navigation, Autoplay } from 'swiper';

const RelatedProductsSwiper = document.querySelector('.RelatedProductsSlider .swiper');
if (RelatedProductsSwiper) {
    const rpSlider = new Swiper(RelatedProductsSwiper, {
        modules: [Autoplay, Navigation],
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: '.RelatedProductsSlider__swiper-next',
            prevEl: '.RelatedProductsSlider__swiper-prev',
        },
    });
}

const CrossSellSlider = document.querySelector('.CrossSellSlider .swiper');
if (CrossSellSlider) {
    const csSlider = new Swiper(CrossSellSlider, {
        modules: [Autoplay, Navigation],
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: '.CrossSellSlider__swiper-next',
            prevEl: '.CrossSellSlider__swiper-prev',
        },
    });
}

const UpSellSlider = document.querySelector('.UpSellSlider .swiper');
if (UpSellSlider) {
    const usSlider = new Swiper(UpSellSlider, {
        modules: [Autoplay, Navigation],
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },

        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: '.UpSellSlider__swiper-next',
            prevEl: '.UpSellSlider__swiper-prev',
        },
    });
}

const ViewedProductsSlider = document.querySelector('.ViewedProductsSlider .swiper');
if (ViewedProductsSlider) {
    const vpSlider = new Swiper(ViewedProductsSlider, {
        modules: [Autoplay, Navigation],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },

        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
        navigation: {
            nextEl: '.ViewedProductsSlider__swiper-next',
            prevEl: '.ViewedProductsSlider__swiper-prev',
        },
    });
}
